import { CompanyPlanStatus } from '../../enum/CompanyPlanLevelEnum';
import {
  isOperationalCountryMexico,
  isSubscriptionFiscalCountryMexico
} from '../company/fiscalSettings';

export enum FiscalFeature {
  MEXICO_CFDI_FIELDS = 'MEXICO_CFDI_FIELDS',
  MEXICO_CFDI_OPERATIONAL = 'MEXICO_CFDI_OPERATIONAL',
  SUBSCRIPTION_BILLING_CFDI = 'SUBSCRIPTION_BILLING_CFDI'
}

type FiscalFeatureVisibilityInput = {
  company?: any | null;
  user?: any | null;
};

export function canShowFiscalFeature(
  feature: FiscalFeature,
  input: FiscalFeatureVisibilityInput
): boolean {
  const { company, user } = input;

  switch (feature) {
    case FiscalFeature.SUBSCRIPTION_BILLING_CFDI:
      return isSubscriptionFiscalCountryMexico(company);

    case FiscalFeature.MEXICO_CFDI_FIELDS:
      return (
        isOperationalCountryMexico(company) &&
        company?.companyServicesPermissions?.canUseCFDIInvoicing === true
      );

    case FiscalFeature.MEXICO_CFDI_OPERATIONAL: {
      const isInGraceOrSuspended = [CompanyPlanStatus.GRACE, CompanyPlanStatus.SUSPENDED].includes(
        company?.planStatus
      );
      const hasCFDIServiceEnabled =
        company?.companyServicesPermissions?.canUseCFDIInvoicing === true;
      const canViewByUserPermission = user?.permission?.cfdi?.canView ?? true;

      return (
        isOperationalCountryMexico(company) &&
        hasCFDIServiceEnabled &&
        !isInGraceOrSuspended &&
        canViewByUserPermission
      );
    }

    default:
      return false;
  }
}
